import { client } from "~/apollo/client";
import { GetComplianceClientsSliceDocument } from "~/graphql/supergraphHooks";
import {
  type GetComplianceClientsSliceQuery,
  type GetComplianceClientsSliceQueryVariables,
} from "~/graphql/supergraphTypes";
import {
  displayOrDash,
  downloadCSV,
  generateTimestampedCsvFilename,
  toCsv,
} from "~/pages/Compliance/utils/csvExport";
import { fetchAllSlicePages } from "~/pages/Compliance/utils/fetchSlicePages";
import type { RowItem } from "./types";

export const CLIENTS_CSV_HEADERS = [
  "Client ID",
  "Client",
  "Entities",
  "Status",
  "Product line",
  "Client program",
  "Onboarding status",
] as const;

export const generateClientsCsv = (rows: RowItem[]): string =>
  toCsv(
    CLIENTS_CSV_HEADERS,
    rows.map((row) => [
      row.id,
      row.client,
      row.entities,
      row.status,
      row.productLine,
      displayOrDash(row.clientProgram),
      displayOrDash(row.onboardingStatus),
    ]),
  );

export const fetchAllComplianceClients = async (): Promise<RowItem[]> =>
  fetchAllSlicePages(async (offset, limit) => {
    const result = await client.query<
      GetComplianceClientsSliceQuery,
      GetComplianceClientsSliceQueryVariables
    >({
      query: GetComplianceClientsSliceDocument,
      variables: { offset, limit },
      fetchPolicy: "no-cache",
    });
    return result.data?.complianceClientsSlice?.rows ?? [];
  });

export const exportComplianceClients = async (): Promise<void> => {
  const rows = await fetchAllComplianceClients();
  downloadCSV(generateClientsCsv(rows), generateTimestampedCsvFilename("clients"));
};
